import { render } from "./FormPhotoVehicleTitleFile.vue?vue&type=template&id=08555745"
import script from "./FormPhotoVehicleTitleFile.vue?vue&type=script&lang=js"
export * from "./FormPhotoVehicleTitleFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__